import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/common/Elements/Elements';

import classes from './BodyTooltip.module.scss';

const BodyTooltip = ({ name, data = [] }) => {
  return (
    <section className={classes.wrap}>
      <Text type={'p'} className={classes.title} weight="m">
        {name}
      </Text>
      {data.map((item, index) => (
        <div className={classes.notifWrap} key={index}>
          <Text type={'p'} className={classes.name} weight="m">
            {item}
          </Text>
        </div>
      ))}
    </section>
  );
};

BodyTooltip.propTypes = {
  name: PropTypes.string,
  data: PropTypes.array,
  subName: PropTypes.string,
  icon: PropTypes.string
};

export default BodyTooltip;
